export default __webpack_public_path__ + "static/media/tileovercutmiddle.cc0b09b4.jpg";